(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeimagen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializarHerotxt(envoltorio) {
      var pista = envoltorio.querySelector('[data-herotxt-pista]');
      var slides = envoltorio.querySelectorAll('[data-herotxt-slide]');
      var botonPrev = envoltorio.querySelector('[data-herotxt-prev]');
      var botonNext = envoltorio.querySelector('[data-herotxt-next]');
      var contenedorPuntos = envoltorio.querySelector('[data-herotxt-puntos]');

      if (!pista || slides.length < 2) return;

      var indiceActual = 0;

      slides.forEach(function (slide, indice) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'herotxt-punto' + (indice === 0 ? ' herotxt-punto--activo' : '');
        punto.setAttribute('aria-label', 'Ir al slide ' + (indice + 1));
        punto.addEventListener('click', function () {
          irASlide(indice);
        });
        if (contenedorPuntos) contenedorPuntos.appendChild(punto);
      });

      var puntos = contenedorPuntos ? contenedorPuntos.querySelectorAll('.herotxt-punto') : [];

      function irASlide(indice) {
        indiceActual = Math.max(0, Math.min(indice, slides.length - 1));
        pista.scrollTo({ left: pista.clientWidth * indiceActual, behavior: 'smooth' });
        puntos.forEach(function (p, i) {
          p.classList.toggle('herotxt-punto--activo', i === indiceActual);
        });
      }

      pista.addEventListener('scroll', function () {
        var nuevoIndice = Math.round(pista.scrollLeft / pista.clientWidth);
        if (nuevoIndice !== indiceActual) {
          indiceActual = nuevoIndice;
          puntos.forEach(function (p, i) {
            p.classList.toggle('herotxt-punto--activo', i === indiceActual);
          });
        }
      });

      if (botonPrev) botonPrev.addEventListener('click', function () { irASlide(indiceActual - 1); });
      if (botonNext) botonNext.addEventListener('click', function () { irASlide(indiceActual + 1); });
    }

    document.querySelectorAll('[data-herotxt-envoltorio]').forEach(function (envoltorio) {
      inicializarHerotxt(envoltorio);
    });

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (evento) {
        var envoltorio = evento.target.querySelector('[data-herotxt-envoltorio]');
        if (envoltorio) inicializarHerotxt(envoltorio);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imagenmodelo2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializarHerotxt(envoltorio) {
      var pista = envoltorio.querySelector('[data-herotxt-pista]');
      var slides = envoltorio.querySelectorAll('[data-herotxt-slide]');
      var botonPrev = envoltorio.querySelector('[data-herotxt-prev]');
      var botonNext = envoltorio.querySelector('[data-herotxt-next]');
      var contenedorPuntos = envoltorio.querySelector('[data-herotxt-puntos]');

      if (!pista || slides.length < 2) return;

      var indiceActual = 0;

      slides.forEach(function (slide, indice) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'herotxt-punto' + (indice === 0 ? ' herotxt-punto--activo' : '');
        punto.setAttribute('aria-label', 'Ir al slide ' + (indice + 1));
        punto.addEventListener('click', function () {
          irASlide(indice);
        });
        if (contenedorPuntos) contenedorPuntos.appendChild(punto);
      });

      var puntos = contenedorPuntos ? contenedorPuntos.querySelectorAll('.herotxt-punto') : [];

      function irASlide(indice) {
        indiceActual = Math.max(0, Math.min(indice, slides.length - 1));
        pista.scrollTo({ left: pista.clientWidth * indiceActual, behavior: 'smooth' });
        puntos.forEach(function (p, i) {
          p.classList.toggle('herotxt-punto--activo', i === indiceActual);
        });
      }

      pista.addEventListener('scroll', function () {
        var nuevoIndice = Math.round(pista.scrollLeft / pista.clientWidth);
        if (nuevoIndice !== indiceActual) {
          indiceActual = nuevoIndice;
          puntos.forEach(function (p, i) {
            p.classList.toggle('herotxt-punto--activo', i === indiceActual);
          });
        }
      });

      if (botonPrev) botonPrev.addEventListener('click', function () { irASlide(indiceActual - 1); });
      if (botonNext) botonNext.addEventListener('click', function () { irASlide(indiceActual + 1); });
    }

    document.querySelectorAll('[data-herotxt-envoltorio]').forEach(function (envoltorio) {
      inicializarHerotxt(envoltorio);
    });

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (evento) {
        var envoltorio = evento.target.querySelector('[data-herotxt-envoltorio]');
        if (envoltorio) inicializarHerotxt(envoltorio);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seleccionmercado"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializarSelmerc(envoltorio) {
      var botonAbrir = envoltorio.querySelector('[data-selmerc-abrir]');
      var fondo = envoltorio.querySelector('[data-selmerc-fondo]');
      var panel = envoltorio.querySelector('[data-selmerc-panel]');
      var botonCerrar = envoltorio.querySelector('[data-selmerc-cerrar]');

      if (!botonAbrir || !fondo || !panel) return;

      function abrir() {
        fondo.hidden = false;
        panel.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function cerrar() {
        fondo.hidden = true;
        panel.hidden = true;
        document.body.style.overflow = '';
      }

      botonAbrir.addEventListener('click', abrir);
      if (botonCerrar) botonCerrar.addEventListener('click', cerrar);
      fondo.addEventListener('click', cerrar);

      document.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape' && !panel.hidden) cerrar();
      });
    }

    document.querySelectorAll('[data-selmerc-envoltorio]').forEach(function (envoltorio) {
      inicializarSelmerc(envoltorio);
    });

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (evento) {
        var envoltorio = evento.target.querySelector('[data-selmerc-envoltorio]');
        if (envoltorio) inicializarSelmerc(envoltorio);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
